import jwt from "jsonwebtoken";
import React from "react";
import {Redirect, Route} from "react-router";
import {safeLocalStorage} from "./storage";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = safeLocalStorage.getItem("Token") || "";
  const themes = token ? jwt.decode(token)["themes"] : [];
  let search = false;
  return (
    <Route
      {...rest}
      render={(props) => {
        const path = props.match.path;
        if (token) {
          search = themes.find(
            (theme) =>
              "/" + theme.toLowerCase().replace(/\s/g, "") ===
              path.toLowerCase().replace(/\s/g, "")
          );
        }
        return search ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/" }} />
        );
      }}
    />
  );
};
export default PrivateRoute;
